module.exports = __webpack_public_path__ + "img/LUB00172.47f49be0.svg";